import { Outlet } from 'react-router-dom'

const Configurations = () => {
  return <Outlet />
}

export default Configurations
